import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import { HydroControllerApi, } from 'cd-eft/services/eftEfh2Api';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import { DelineateWatershedInputStateVM } from '../DelineateWatershedInput/DelineateWatershedInputStateVM';

const __noHsgData = [
  { "hsg": "A", "pct": 0 },
  { "hsg": "B", "pct": 0 },
  { "hsg": "C", "pct": 0 },
  { "hsg": "D", "pct": 0 }
];
const __noHsgDataNoA = [
  { "hsg": "B", "pct": 0 },
  { "hsg": "C", "pct": 0 },
  { "hsg": "D", "pct": 0 }
];
interface IEditSoilAndLandProps {
  soilArray: Array<any>;
  landArray: Array<any>;
  callback: (soil: [], land: [], vm: any) => void;
  view: any;
  onCheckboxRowChanged: (data: any, layerType: number) => void;
  landUseTableComplete: boolean;
  currentStepIndex: number;
  activityViewModel: DelineateWatershedInputStateVM;
}

export class EditSoilAndLandVM {
  @observable props: IEditSoilAndLandProps;
  setForceRender: any;
  renderCount: number;
  constructor(props: IEditSoilAndLandProps, setForceRender: any) {
    this.props = props;
    this.setForceRender = setForceRender;
    this.renderCount = 0;

    this.props.activityViewModel.editSoilVm = this;
    this.props.activityViewModel.forceSyncSoilSelection();
  }
  @observable landUseTable: any = [];
  @observable soilTable: any = [];
  @observable soilTableValues: any = [];
  @observable mukeyArray: any = [];
  @observable showSoilTable: boolean = false;
  @observable selectAllSoilItems: boolean = false;
  @observable selectAllLandItems: boolean = false;
  @observable showHsgDetails: boolean = false;
  @observable loadingSalResults: boolean = false;

  // Land functions following implementation of Soil functions
  @observable checkedLandUse: any = [];

  @action.bound toggleShowHsgDetails() {
    this.showHsgDetails = !this.showHsgDetails;
  }
  @action.bound onAllLandUseRowCheckChanged(e) {
    const ids: any = [];
    if (e.target.checked) {
      for (const item of this.landUseTable) {
        ids.push(item.attributes.OBJECTID);
      }
    }
    this.selectAllLandItems = e.target.checked;
    this.checkedLandUse = ids;
  }

  @action.bound onLandUseRowCheckChanged(e) {
    const objectid = parseInt(e.target.name);
    const checked = e.target.checked;

    if (checked && this.checkedLandUse.indexOf(objectid) < 0) {
      this.checkedLandUse.push(objectid);
      this.checkedLandUse.sort();
    } else if (!checked && this.checkedLandUse.indexOf(objectid) >= 0) {
      this.checkedLandUse.splice(this.checkedLandUse.indexOf(objectid), 1);
      this.checkedLandUse.sort();
    }
    // Master checkbox checked state
    this.selectAllLandItems = this.checkedLandUse.length === this.landUseTable.length;
  }

  // Could this be merged with clearSoilsCheckboxes into one function?
  @action.bound clearLandCheckboxes() {
    this.selectAllLandItems = false;
    this.checkedLandUse = [];
  }

  // Soil Checkbox Functions
  @observable checkedSoils: any = [];
  @action.bound onAllSoilsRowCheckChanged(e) {
    const ids: any = [];
    if (e.target.checked) {
      for (const item of this.soilTable) {
        ids.push(item.attributes.OBJECTID);
      }
    }

    this.selectAllSoilItems = e.target.checked;
    this.checkedSoils = ids;
    this.raiseSoilsCheckedRowsChanged(this.checkedSoils);
  }
  @action.bound onSoilsRowCheckChanged(e) {
    const objectid = parseInt(e.target.name);
    const checked = e.target.checked;

    if (checked && this.checkedSoils.indexOf(objectid) < 0) {
      this.checkedSoils.push(objectid);
      this.checkedSoils.sort();
    } else if (!checked && this.checkedSoils.indexOf(objectid) >= 0) {
      this.checkedSoils.splice(this.checkedSoils.indexOf(objectid), 1);
      this.checkedSoils.sort();
    }

    //check mastercheckbox state
    this.selectAllSoilItems = this.checkedSoils.length === this.soilTable.length;

    this.raiseSoilsCheckedRowsChanged(this.checkedSoils);
  }

  private raiseSoilsCheckedRowsChanged(e) {
    this.props.activityViewModel.selectedSoils.splice(0, this.props.activityViewModel.selectedSoils.length);
    for (const id of e) {
      this.props.activityViewModel.selectedSoils.push(id);
    }
    this.props.activityViewModel.syncSoilSelection();
  }

  public syncSoilSelection(ids: number[]) {
    this.checkedSoils.splice(0, this.checkedSoils.length);
    for (const id of ids) {
      this.checkedSoils.push(id);
    }
    this.checkedSoils.sort();

    //check mastercheckbox state
    this.selectAllSoilItems = this.checkedSoils.length === this.soilTable.length;

    this.raiseSoilsCheckedRowsChanged(this.checkedSoils);
  }

  @action.bound handleSoilRowMouseEnter(e: any, i: number) {
    this.handleSoilRowSelectChange(i, true);
  }

  @action.bound handleSoilRowMouseLeave(e: any, i: number) {
    this.handleSoilRowSelectChange(i, false);
  }

  private handleSoilRowSelectChange(i: number, select: boolean) {
    const soil = this.soilTable[i];
    if (soil) {
      const objectId = soil.attributes['OBJECTID'];
      if (objectId) {
        if (select) {
          this.props.activityViewModel.highlightSoil(objectId);
        } else {
          this.props.activityViewModel.removeHighlightSoil(objectId);
        }
      }
    }
  }

  @observable hydroGroupOptions: any = ['A', 'B', 'C', 'D'];
  @observable landConditionOptions: any = [];

  @observable landUseOptions: any = [];

  lulcLinkedValueOptions: any[] = [];

  mukeyResults: any = null;
  @action.bound getHsgData(mukey: number, noA: number) {
    let result: any = null;
    if (this.mukeyResults) {
      const queryResult = this.mukeyResults.filter(function (currentValue, index, array) {
        if (currentValue.mukey === mukey) {
          return true;
        } else {
          return false;
        }
      });
      if (queryResult[0] && queryResult[0].hsgdata) {
        result = (
          noA === 1 ?
            queryResult[0].hsgdata.filter((h) => { return (h.hsg !== "A"); }) :
            queryResult[0].hsgdata);
      } else {
        result = (noA === 1 ? __noHsgDataNoA : __noHsgData);
      }
    }

    return result;
  }

  mukeyDetailsResults: any = null;
  @action.bound getHsgDetailsData(mukey: number) {
    let result: any = null;
    if (this.mukeyDetailsResults) {
      const queryResult = this.mukeyDetailsResults.filter(function (currentValue, index, array) {
        if (currentValue.mukey === mukey) {
          return true;
        } else {
          return false;
        }
      });
      if (queryResult[0] && queryResult[0].hsgdata) {
        result = queryResult[0].hsgdata;
      }
    }

    return result;
  }

  // Initiates tables and adds a selected value to each table's array
  @action.bound async initTables(soilTable, landTable) {
    this.soilTable = soilTable;
    this.landUseTable = landTable;
    this.loadingSalResults = true;
    await this.getLulcData();

    ///BEGIN fetch mukey extended data from API CALL
    const mukeyList: any = [];
    if (this.soilTable.length) {
      for (const row of this.soilTable) {
        const mukey = row.attributes.MUKEY;
        if ((mukey > 0) && !mukeyList.includes(mukey)) {
          mukeyList.push(mukey);
        }
      }
    }
    mukeyList.sort();

    const newMukeyList: any = [];
    for (let i = 0; i < mukeyList.length; i++) {
      newMukeyList.push({ mukey: mukeyList[i] });
    }

    const newResults: any = [];
    const newResultsDetails: any = [];

    for (const row of this.soilTable) {
      if (row.attributes.MUKEY === 0) {
        row.attributes.HYDGROUP = 'D';
        const mapUnitItem = {
          mukey: 0,
          hsgdata: [{ hsg: 'D', pct: 100 }],
        };
        newResults.push(mapUnitItem);

        const mapUnitItemDetails = {
          mukey: 0,
          hsgdata: [{ hsg: 'D', pct: 100 }],
        };
        newResultsDetails.push(mapUnitItemDetails);
      }
    }

    if (mukeyList.length > 0) {
      const response = await HydroControllerApi.getDualSoilPctByMukeysUsingPOST(newMukeyList);

      if (response && response.data && response.data.dualSoilOutput) {
        const mukeyResults = response.data.dualSoilOutput;
        for (const item of mukeyResults) {
          const filteredTable = this.soilTable.filter((el) => {
            return el.attributes.MUKEY === item.mukey;
          });

          const highestPercentLetter = ['a', 'b', 'c', 'd'].reduce((a, b) => (item[a] > item[b] ? a : b));

          if (item.dual_soil30pct_over === 'NO') {
            for (const soilItem of filteredTable) {
              if (!soilItem.attributes.HYDGROUP && !((soilItem.attributes.NO_A_HSG === 1) && (highestPercentLetter === 'a'))) {
                soilItem.attributes.HYDGROUP = highestPercentLetter.toUpperCase();
              }
            }
          }

          const template = [
            { hsg: 'A', pct: -1 },
            { hsg: 'B', pct: -1 },
            { hsg: 'C', pct: -1 },
            { hsg: 'D', pct: -1 },
          ];

          const templateResults = [
            { hsg: 'A', pct: -1 },
            { hsg: 'B', pct: -1 },
            { hsg: 'C', pct: -1 },
            { hsg: 'D', pct: -1 },
            { hsg: 'A/D', pct: -1 },
            { hsg: 'B/D', pct: -1 },
            { hsg: 'C/D', pct: -1 },
          ];

          template[0].pct = item.a!;
          template[1].pct = item.b!;
          template[2].pct = item.c!;
          template[3].pct = item.d!;

          templateResults[0].pct = item.a!;
          templateResults[1].pct = item.b!;
          templateResults[2].pct = item.c!;
          templateResults[3].pct = item.d!;
          templateResults[4].pct = item.ad!;
          templateResults[5].pct = item.bd!;
          templateResults[6].pct = item.cd!;

          const mapUnitItem = {
            mukey: item.mukey,
            hsgdata: template,
          };
          newResults.push(mapUnitItem);

          const mapUnitItemDetails = {
            mukey: item.mukey,
            hsgdata: templateResults,
          };
          newResultsDetails.push(mapUnitItemDetails);
        }
      }
    }
    this.mukeyDetailsResults = newResultsDetails;
    this.mukeyResults = newResults;

    if (this.mukeyResults) {
      this.props.activityViewModel.createSnapShot();
    }

    this.renderCount++;
    this.setForceRender(this.renderCount);
    this.checkValues();

    this.loadingSalResults = false;
    this.props.activityViewModel.createSnapShotNewStep();
    // END fetch mukey extended data from API CALL
  }

  @action.bound checkValues() {
    if (this.props.activityViewModel.edit_SAL_LANDUSE_graphicsLayerView) {
      // Conditions that we do not want to be selected
      const layer = this.props.activityViewModel.edit_SAL_LANDUSE_graphicsLayerView.layer as GraphicsLayer;
      const landuseNull = layer.graphics.some(
        (item) => item.attributes.LANDUSE === null || item.attributes.LANDUSE === undefined
      );
      const landuseString = layer.graphics.some((item) => item.attributes.LANDUSE === '');
      const conditionNull = layer.graphics.some(
        (item) => item.attributes.CONDITION === null || item.attributes.CONDITION === undefined
      );
      const conditionString = layer.graphics.some((item) => item.attributes.CONDITION === '');

      // If any of these are true we keep user from moving onward
      if (landuseNull || conditionNull || landuseString || conditionString) {
        stores.AppStore.efh2Store.projectsStore.landErrors = true;

        // If all conditions are false we allow them to move on
      } else if (!landuseNull && !conditionNull && !landuseString && !conditionString) {
        stores.AppStore.efh2Store.projectsStore.landErrors = false;
      }
    }

    if (this.soilTable) {
      const hydroNull = this.soilTable.some((item) => (item.attributes.HYDGROUP === null) || (item.attributes.HYDGROUP === undefined));
      const hydroString = this.soilTable.some((item) => item.attributes.HYDGROUP === '');

      if (hydroNull || hydroString) {
        stores.AppStore.efh2Store.projectsStore.soilErrors = true;
      } else if (!hydroNull && !hydroString) {
        stores.AppStore.efh2Store.projectsStore.soilErrors = false;
      }
    }
  }

  @action.bound async getLulcData() {
    try {
      const response: any = await HydroControllerApi.getAllLulccnlutsForFTUpUsingGET();

      this.lulcLinkedValueOptions = [];
      this.landUseOptions = [];

      if (response) {
        response.data.forEach((element) => {
          this.landUseOptions.push(element.lulcPK);

          const linkValueOption: any = {};
          linkValueOption.linkedValue = element.lulcPK;
          linkValueOption.linkedOptions = element.lcConditionList.map((item) => {
            if (item === null || item === '----') {
              item = 'N/A';
            }

            item = item.split(' ');
            for (let i = 0, x = item.length; i < x; i++) {
              item[i] = item[i][0].toUpperCase() + item[i].substr(1);
            }
            item.join(' ');

            return { name: item, value: item };
          });
          this.lulcLinkedValueOptions.push(linkValueOption);
        });
      }
    } catch (error) {
      console.error('Error from getLulcData:', error);
    }
  }

  @action.bound handleInputChange(event: any, index: number, table: any) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    table[index].attributes[name] = value;

    //make sure to include required SalVM reference as last argument
    this.props.callback(this.soilTable, this.landUseTable, this);

    // Check if values are all selected correctly
    this.checkValues();

    this.props.activityViewModel.hydrologyValidationError = false;
  }

  @action.bound errorClass(key, value) {
    let validValue = false;
    if (key === 'HYDGROUP') {
      if (this.hydroGroupOptions.includes(value)) validValue = true;
    } else if (key === 'LANDUSE') {
      if (this.landUseOptions.includes(value)) validValue = true;
    } else if (key === 'CONDITION') {
      if (this.landConditionOptions.includes(value)) validValue = true;
    }
    return validValue ? '' : ' usa-input--error';
  }

  @action.bound landUseValidator(value: any) {
    let validValue: boolean = false;
    if (this.landUseOptions.includes(value)) { validValue = true };
    this.props.activityViewModel.hydrologyValidationError = false;
    return validValue;
  }

  @action.bound landUseConditionValidator(value: any) {
    let validValue: boolean = false;
    const conditionOptions = ['Good', 'Fair', 'Poor', 'N/A'];
    if (conditionOptions.includes(value)) { validValue = true };
    this.props.activityViewModel.hydrologyValidationError = false;
    return validValue;
  }
}
